goog.provide('el8.uiwidget.ClickText');

goog.require('el8.template.uiwidget.ClickText');
goog.require('el8.util.consts');
goog.require('el8.util.string');


/**
 * This widget renders "click-to-edit" text, which will
 * save when is done being edited. It will switch back
 * and forth between a static HTML text appearance and
 * and an editable form appearance depending on the mode
 * it's in.
 *
 * See the problem synopsis field in the clinical profile
 * (refpanel/problems.js) for an example usage.
 */
el8.uiwidget.ClickText = function(opts) {
    opts = opts || {};
    this._spellcheck = opts.spellcheck || el8.util.consts.SPELLCHECK;
    this._maxLength = opts.maxLength || null;
    this._fieldHeight = opts.fieldHeight || el8.util.consts.DEFAULT_FIELD_HEIGHT;
    this._height = opts.height || null;
    this._changeFn = opts.changeFn || null;

    /* Holds state */
    this._isEditMode = false;
};

el8.uiwidget.ClickText.prototype.init = function(spec) {

    spec = spec || {};
    var $elt = spec.elt;
    var initText = spec.initText || '';

    this._contentElt = $(el8.template.uiwidget.ClickText.content({
        spellcheck: this._spellcheck,
        maxLength: this._maxLength
    }));
    $elt.html(this._contentElt);

    this._displayEltWrapper = $('.ct-display-wrapper', this._contentElt); // show/hide elt
    this._textElt = $('.ct-display-text', this._contentElt); // actual text elt
    this._textEltIcon = $('.ct-edit-icon', this._contentElt);
    this._editElt = $('.ct-edit', this._contentElt);

    if (this._height) { this._contentElt.height(this._height); }
    this._editElt.height(this._fieldHeight).css('width', '100%').attr('height', this._fieldHeight);

    var that = this;
    this._editElt.on('click', function(e) {
        that._setEditMode();
        return false;
    }).on('blur', function(e) {
        that._setDisplayMode();
        return false;
    }).on('keyup', function(e) {
        var field = $(this);
        el8.util.dom.growShrinkTextarea(field, that._contentElt, that._fieldHeight);
    });
    $('.ct-display-trigger', this._contentElt).on('click', function(e) {
        that._setEditMode();
        return false;
    });
    if (this._changeFn) {
        this._editElt.on('change', function(e) {
            that._changeFn(that.getText());
            return false;
        });
    }

    if (initText) { this.setText(initText); }
    this._setDisplayMode();
    return this;
};

el8.uiwidget.ClickText.prototype.setText = function(text) {
    this._textElt.html(el8.util.string.newlinesToBr(text));
    this._setEditVal(text);
};

el8.uiwidget.ClickText.prototype.getText = function() {
    return this._isEditMode ? this._editElt.val() :
        el8.util.string.brToNewlines(this._textElt.html()).el8_unescape();
};

el8.uiwidget.ClickText.prototype.setFocus = function() {
    this._setEditMode();
};

el8.uiwidget.ClickText.prototype.triggerResize = function() {
    el8.util.dom.growShrinkTextarea(this._editElt, this._contentElt, this._fieldHeight);
};

el8.uiwidget.ClickText.prototype._setEditVal = function(text) {
    this._editElt.val(text);
    el8.util.dom.growShrinkTextarea(this._editElt, this._contentElt, this._fieldHeight);
};

el8.uiwidget.ClickText.prototype._setEditMode = function() {
    if (this._isEditMode) { return; } // don't move the cursor if the user is editing

    this._isEditMode = true;
    /* No need to update this._editElt's val because any changes
     * to the text always go through editElt anyway, so it
     * shouldn't be out of date */
    this._editElt.show();

    // move cursor to end of input
    var val = this._editElt.val();
    if (val) { el8.util.dom.moveCursor(this._editElt, val.length); }

    this._editElt.focusFocus();

    this._displayEltWrapper.hide();
};

el8.uiwidget.ClickText.prototype._setDisplayMode = function() {
    this._isEditMode = false;
    var val = this._editElt.val();
    var displayVal = el8.util.string.newlinesToBr(val.el8_unescape());
    this._textElt.html(displayVal);

    // show the edit icon if there's text in the ct-display; otherwise, hide it
    if (displayVal) {
        this._textEltIcon.show();
    } else {
        this._textEltIcon.hide();
    }

    // if there's no text yet, keep the textarea visible so the user can click through it to edit
    if (val) {
        this._editElt.hide();
    }
    this._displayEltWrapper.show();
};
